/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Linkedcontent1Inputs */

const zh_course_linkedcontent1 = /** @type {(inputs: Course_Linkedcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已关联`)
};

const en_course_linkedcontent1 = /** @type {(inputs: Course_Linkedcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linked`)
};

const es_course_linkedcontent1 = /** @type {(inputs: Course_Linkedcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vinculado`)
};

/**
* | output |
* | --- |
* | "Linked" |
*
* @param {Course_Linkedcontent1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const course_linkedcontent1 = /** @type {((inputs?: Course_Linkedcontent1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Linkedcontent1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_linkedcontent1(inputs)
	if (locale === "en") return en_course_linkedcontent1(inputs)
	return es_course_linkedcontent1(inputs)
});
export { course_linkedcontent1 as "course_linkedContent" }